import React, { useMemo } from 'react';
import CommonChart from '../CommonChart';
import { getCompetitorBatchTopicTimeLine } from '@/pages/opinion/services';

export default function TopicChart({
  xAxisList,
  dau,
  commonParams,
  isNoMobile,
  transformFunc,
}: any) {
  const filter = useMemo(() => {
    return { ...commonParams, source: ['steam', 'opencritic', 'metacritic'] };
  }, [commonParams]);

  return (
    <CommonChart
      xAxisList={xAxisList}
      dau={dau}
      commonParams={filter}
      isNoMobile={isNoMobile}
      requestFunc={getCompetitorBatchTopicTimeLine}
      selectTitle="Topic"
      title="Topic"
      transformFunc={transformFunc}
    ></CommonChart>
  );
}
